import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ForumService } from './forum.service';
import { Topic } from './topic';

@Component({
    selector: 'forum',
    template: require('./forum.component.html'),
    providers: [ForumService]
})

export class ForumComponent implements OnInit {

    router: Router;
    userStatus: string;
    isCollapsed: boolean = false;
    searchFilter: string;
    userName: string;
    nMessages: number;
    elementsThatContainsSearchValueById: Element[];
    elementsThatContainsSearchValueByName: Element[];
    loginCode: number;
    loginPassword: string;
    loginEmail: string;
    classLoginModal: any;
    classForgetPasswordModal: any;
    forgetPasswordEmail: string;
    forgetPasswordEmailEmpty: boolean;
    forgetPasswordEmailIncorrect: boolean;
    classEmailSendedModal: any;
    emailSended: boolean;

    constructor(private _forumService: ForumService, _parentRouter: Router) {
        this.router = _parentRouter;
        this.userStatus = "";
        this.searchFilter = "";
        this.userName = "";
        this.nMessages = 0;
        this.elementsThatContainsSearchValueById = [];
        this.elementsThatContainsSearchValueByName = [];
        this.loginCode = 0;
        this.loginPassword = "";
        this.loginEmail = "";
        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
        this.classForgetPasswordModal = { 'model': true, 'show': false, 'hide': true };
        this.forgetPasswordEmail = "";
        this.forgetPasswordEmailEmpty = false;
        this.forgetPasswordEmailIncorrect = false;
        this.classEmailSendedModal = { 'model': true, 'show': false, 'hide': true };
        this.emailSended = false;
    }

    ngOnInit() {
        this._forumService.getUserStatus().then(status => {
            this.userStatus = status.role;
            if (this.userStatus == "admin" || this.userStatus == "superuser" || this.userStatus == "user") {
                this.userName = this._forumService.getUserName();
                this._forumService.getUnreadMessages().then(res => {
                    if (res != null) {
                        this.nMessages = res.length;
                    }
                });
            }

        });
    }

    collapse(): void {
        this.isCollapsed = true;
    }

    noCollapse() {
        this.isCollapsed = false;
    }

    searchFilterChanged(event: any) {
        if (this.searchFilter.length > 0) {
            if (event.key == "Enter") {
                this.router.navigate(['/main', 'dashboard', { categoryType: null, sellerType: null, citiesFilter: null, tagsFilter: null, searchFilter: this.searchFilter }]);
                this.elementsThatContainsSearchValueById = [];
                this.elementsThatContainsSearchValueByName = [];
            } else {
                if (this.userStatus == "guest") {
                    this._forumService.getElementsBySearchFilterValue(this.searchFilter).then(res => {
                        this.elementsThatContainsSearchValueById = [];
                        this.elementsThatContainsSearchValueByName = [];
                        if (res != null) {
                            for (var i = 0; i < res.length; i++) {
                                var introduced = false;
                                if (res[i].comercial_name.toUpperCase().includes(this.searchFilter.toUpperCase()) && !introduced) {
                                    this.elementsThatContainsSearchValueByName.push(res[i]);
                                    introduced = true;
                                }
                                if (res[i].id.toString().includes(this.searchFilter) && !introduced) {
                                    this.elementsThatContainsSearchValueById.push(res[i]);
                                    introduced = true;
                                }
                                if ((res[i].id.toString() + " " + res[i].comercial_name).toUpperCase().includes((this.searchFilter.toUpperCase())) && !introduced) {
                                    this.elementsThatContainsSearchValueByName.push(res[i]);
                                    introduced = true;
                                }
                            }
                        }
                    });
                } else {
                    this._forumService.getElementsAuthenticatedBySearchFilterValue(this.searchFilter).then(res => {
                        this.elementsThatContainsSearchValueById = [];
                        this.elementsThatContainsSearchValueByName = [];
                        if (res != null) {
                            for (var i = 0; i < res.length; i++) {
                                var introduced = false;
                                if (res[i].comercial_name.toUpperCase().includes(this.searchFilter.toUpperCase()) && !introduced) {
                                    this.elementsThatContainsSearchValueByName.push(res[i]);
                                    introduced = true;
                                }
                                if (res[i].id.toString().includes(this.searchFilter) && !introduced) {
                                    this.elementsThatContainsSearchValueById.push(res[i]);
                                    introduced = true;
                                }
                                if ((res[i].id.toString() + " " + res[i].comercial_name).toUpperCase().includes((this.searchFilter.toUpperCase())) && !introduced) {
                                    this.elementsThatContainsSearchValueByName.push(res[i]);
                                    introduced = true;
                                }
                            }
                        }
                    });
                }
            }
        } else {
            this.elementsThatContainsSearchValueById = [];
            this.elementsThatContainsSearchValueByName = [];
        }
    }

    searchDataClicked(element: Element) {
        this.searchFilter = "";
        this.elementsThatContainsSearchValueById = [];
        this.elementsThatContainsSearchValueByName = [];
        this.router.navigate(['/main', 'elementdetail', { categoryType: null, sellerType: null, citiesFilter: null, tagsFilter: null, elementId: element.id, scroll: document.body.scrollTop, scrollHeight: document.body.scrollHeight, loadedPage: 0 }]);
    }

    searchFilterFocusOut() {
        setTimeout(() => {
            this.elementsThatContainsSearchValueById = [];
            this.elementsThatContainsSearchValueByName = [];
        }, 200);
    }

    toProfileClicked() {
        if (this.userStatus == "superuser" || this.userStatus == "admin") {
            this._forumService.getUserStatus().then(res => {
                localStorage.setItem("userActive", res.active);
                this.router.navigate(['/superuser', 'dashboard']);
            });       
        } else {
            this.router.navigate(['/main', 'profile']);
        }
    }

    accesButtonClicked() {

        if (this.userStatus == "guest") {

            this.classLoginModal.show = true;
            this.classLoginModal.hide = false;

        } else if (this.userStatus == "superuser" || this.userStatus == "admin" || this.userStatus == "user") {

            localStorage.removeItem('token');
            localStorage.removeItem('userName');
            localStorage.removeItem('idUser');
            localStorage.removeItem('lang');
            this.router.navigate(['/main', 'dashboard']);
            location.reload();

        }

    }

    loginClicked() {

        this._forumService.login(this.loginEmail, this.loginPassword).subscribe(result => {
            this.loginCode = result.code;
            if (result !== null && result.token !== undefined) {
                localStorage.setItem('userName', result.user.name);
                localStorage.setItem('idUser', result.user.id.toString());
                location.reload();
                //this.router.navigate(['/main', 'dashboard']);
            }
        });

    }

    registerClicked() {
        this.router.navigate(['/register']);
    }

    forgetPassword() {
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
        this.classForgetPasswordModal.show = true;
        this.classForgetPasswordModal.hide = false;
    }

    closeLoginModal() {
        this.loginCode = 0;
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
    }

    resendEmailRecoverPassword() {
        this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(res => {
            if (res == 1) {
                this.emailSended = true;
            }
        });
    }

    closeForgetPasswordModal() {
        this.classForgetPasswordModal.show = false;
        this.classForgetPasswordModal.hide = true;
        this.forgetPasswordEmail = "";
        this.forgetPasswordEmailEmpty = false;
        this.forgetPasswordEmailIncorrect = false;
    }

    getPasswordByEmail() {
        if (this.forgetPasswordEmail != undefined && this.forgetPasswordEmail != null && this.forgetPasswordEmail != "") {
            this.forgetPasswordEmailEmpty = false;
            this._forumService.verifyEmail(this.forgetPasswordEmail).then(res => {
                if (res) {
                    this.forgetPasswordEmailIncorrect = false;
                    this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(res => {
                        if (res == 1) {
                            this.classForgetPasswordModal.show = false;
                            this.classForgetPasswordModal.hide = true;
                            this.forgetPasswordEmailEmpty = false;
                            this.forgetPasswordEmailIncorrect = false;

                            this.classEmailSendedModal.show = true;
                            this.classEmailSendedModal.hide = false;
                        }
                    })
                } else {
                    this.forgetPasswordEmailIncorrect = true;
                }
            });
        } else {
            this.forgetPasswordEmailEmpty = true;
        }
    }

    closeEmailSendedModal() {
        this.classEmailSendedModal.show = false;
        this.classEmailSendedModal.hide = true;
        this.forgetPasswordEmail = "";
        this.emailSended = false;
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/forum/forum.component.ts
 **/